import styled from "styled-components";
import "./App.css";
import Router from "./routes/Router";

const AppDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100vw;
  background-color: #f0f0f0;
`;

function App() {
  return (
    <>
      <AppDiv>
        <Router />
      </AppDiv>
    </>
  );
}

export default App;
